module.exports = __webpack_public_path__ + "SC04.f7ac9b27.png";